import { Grid } from "@mui/material";
import { memo, useLayoutEffect, useMemo } from "react";

import { useDashboard } from "../../../../store/contexts/DashBoardContext";
import DashBoardComponent from "./DashBoardComponent";

const ComponentsList: React.FC<{ height?: number; width?: number }> = ({
  height,
  width,
}) => {
  const {
    dashboard: { dashboardEstablishmentComponents },
    onChangeHeightWidth,
  } = useDashboard();

  const filtered = useMemo(
    () =>
      dashboardEstablishmentComponents
        ? dashboardEstablishmentComponents
            .sort((a, b) => a.displayOrder - b.displayOrder)
            .filter((d) => d.enable)
        : [],
    [dashboardEstablishmentComponents]
  );

  useLayoutEffect(() => {
    onChangeHeightWidth(width, height);
  }, [width, height, onChangeHeightWidth]);

  return (
    <Grid container spacing={2}>
      {filtered.map((c) => (
        <DashBoardComponent
          data={c}
          components={dashboardEstablishmentComponents}
          key={c.id}
        />
      ))}
    </Grid>
  );
};
export default memo(ComponentsList);
